// global shared items
require('./shared')

require('./shared_functions')

// required plugins
require('../../../../core/js/plugins/mtc_slick');

// item specific JS
require('../site_scripts/mtc_vue_import')
require('../site_scripts/mtc_item_images')
require('../../js/fpa/create-slider')
require('../../js/fpa/image_slider')
require('../../js/fpa/image_gallery_slider')
require('../../js/fpa/popup_image_slider')
require('../../js/fpa/key_features_slider')
require('../../js/fpa/description')
require('../../js/fpa/init_horizontal_accordion')
require('../../js/fpa/vertical-accordion')
require('../../js/fpa/finance-calculator')
require('../../js/fpa/image_gallery')
require('../../js/fpa/open_slider')
require('../../js/fpa/promises_tooltips')
require('../../js/fpa/init_fpa_mobile_menus')
require('../../js/fpa/promises_slider')
require('../../js/fpa/extras')
require('../../js/fpa/silverbullet_options')
require('../../js/fpa/sticky_menu')
require('../../js/fpa/floating_sidebar')
require('../../js/fpa/sticky_footer')
require('../../js/fpa/sharethis')
require('../../js/fpa/ev_savings_graph')
require('../site_scripts/mtc_submit_form')
require('../site_scripts/mtc_enquiry_form_overlay')
require('../site_scripts/mtc_slide_out_menu')
require('../site_scripts/mtc_360_vehicle_images')
require('../site_scripts/mtc_site_wide_messages')
require('../site_scripts/mtc_carz_mobile_menu')
require('../site_scripts/mtc_carz_footer_menu_trigger')
require('../site_scripts/mtc_trigger_finance_calculator');
require('../site_scripts/mtc_item_card_slider');
require('../site_scripts/mtc_trigger_pv_promise')
require('../site_scripts/mtc_storefront_popup')
require('../site_scripts/mtc_new_item_tabs.js')

// TODO: refactor scripts into fpa directory
require('../fpa/zapmap-overlay.js');

// FPA / item specific styles
require('../../styles/entry/fpa.less')
